class UGProductShopNow extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.ug-product-buy-button');
    this.init();
  }

  init() {
    this.button?.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if (!this.button?.getAttribute('data-product-url')) {
      return;
    }
    let productObj;
    try {
      productObj = JSON.parse(this.button.getAttribute('data-product-url'));
    } catch (error) {
      console.warn('Failed to parse product URL data:', error);
      return;
    }
    let channelUrlList = productObj?.channel_url_list;
    if (!Array.isArray(channelUrlList) || channelUrlList.length === 0) {
      return;
    }

    if (channelUrlList.length === 1) {
      window.open(channelUrlList[0], '_blank');
    } else if (channelUrlList.length > 1) {
      let market = this.button?.getAttribute('data-market');
      let module = this.button?.getAttribute('data-module') || '';
      let params = {
        market,
        urlList: channelUrlList,
        module,
      };
      if (
        typeof window.ugProductShowData?.productShopOpenFn === 'function'
      ) {
        const trackModule = module ? `${module} Pop-up` : 'Pop-up';
        document.querySelector('.ug-tk-contentin')?.setAttribute('data-track-event-parameters', JSON.stringify({exposure_event_name: 'store_channel_impression', module: trackModule, product_sku: this.button?.getAttribute('data-product-sku')}));
        window.ugProductShowData.productShopOpenFn(params);
      }
    }
  }
}

customElements.define('ug-product-shop-now', UGProductShopNow);
